import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// Extend dayjs with required plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// Set the default timezone to Europe/London
dayjs.tz.setDefault("Europe/London");

export default dayjs;
